import { render } from "./ComPlusButton.vue?vue&type=template&id=4ab8df4a&ts=true"
import script from "./ComPlusButton.vue?vue&type=script&lang=ts"
export * from "./ComPlusButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__